// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yield-list {
  margin-top: 0.5rem;
}

.yield-list__header {
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  margin-bottom: 0.25rem;
  font-size: 1rem;
}

.yield-list__entries {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  font-size: 1rem;
  text-align: center;
}

.yield-list__row {
  display: inline-flex;
  align-items: baseline;
  justify-content: center;
  gap: 0.4rem;
}

.yield-list__year {
  font-variant-numeric: tabular-nums;
  font-weight: 500;
}

.yield-list__separator {
  opacity: 0.5;
}

.yield-list__weight {
  font-weight: 600;
}

.yield-list__empty {
  margin: 0;
  color: rgba(0, 0, 0, 0.6);
  font-size: 0.8rem;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/yearly-yield-list/yearly-yield-list.component.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":[".yield-list {\n  margin-top: 0.5rem;\n}\n\n.yield-list__header {\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.25rem;\n  margin-bottom: 0.25rem;\n  font-size: 1rem;\n}\n\n.yield-list__entries {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n  font-size: 1rem;\n  text-align: center;\n}\n\n.yield-list__row {\n  display: inline-flex;\n  align-items: baseline;\n  justify-content: center;\n  gap: 0.4rem;\n}\n\n.yield-list__year {\n  font-variant-numeric: tabular-nums;\n  font-weight: 500;\n}\n\n.yield-list__separator {\n  opacity: 0.5;\n}\n\n.yield-list__weight {\n  font-weight: 600;\n}\n\n.yield-list__empty {\n  margin: 0;\n  color: rgba(0, 0, 0, 0.6);\n  font-size: 0.8rem;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
